import { useContext } from 'react'
import { ViewportContext } from '../contexts/viewPort'
export const useViewport = () => {
  const viewPort = useContext(ViewportContext)
  const { width, height } = viewPort || {}
  return { width, height }
}
